import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/shared/guards/auth.guard';
import { ServiceRequestComponent } from './components/service-request.component';
import { ServiceRequestDetailsComponent } from './components/service-request-details/service-request-details.component';
import { ServiceRequestAddAgentComponent } from './components/service-request-add-agent/service-request-add-agent.component';
const ɵ0 = {
    breadcrumb: 'Ordens de Serviço'
}, ɵ1 = {
    breadcrumb: 'Nova Solicitação de Serviço'
}, ɵ2 = {
    breadcrumb: 'Associação de Técnico'
};
const routes = [
    {
        path: 'serviceRequest/list',
        component: ServiceRequestComponent,
        canActivate: [AuthGuard],
        data: ɵ0,
    },
    {
        path: 'serviceRequest/details',
        component: ServiceRequestDetailsComponent,
        canActivate: [AuthGuard],
        data: ɵ1
    },
    {
        path: 'serviceRequest/add-agent',
        component: ServiceRequestAddAgentComponent,
        canActivate: [AuthGuard],
        data: ɵ2
    }
];
export class ServiceRequestRoutingModule {
}
export { ɵ0, ɵ1, ɵ2 };
